import Navbar from "../components/Navbar";
import About from "../components/About";
import Footer from "../components/Footer";
import "../styles/home.css";

function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="cdh-page">
        <About />
      </main>
      <Footer />
    </>
  );
}

export default AboutPage;
